import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MailingsPageComponent } from './components/mailings-page/mailings-page.component';
import { TelegramPageComponent } from './components/telegram-page/telegram-page.component';
import { MessagingApiService } from './services/messaging-api/MessagingApiService';

@NgModule({
  declarations: [
    MailingsPageComponent,
    TelegramPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  providers: [
    provideHttpClient(),
    MessagingApiService,
  ],
  exports: [
    MailingsPageComponent,
    TelegramPageComponent,
  ],
})
export class MessagingModule { }
